import { Autocomplete, Chip, TextField } from '@mui/material'

interface Props {
  options: string[]
  selected: string[]
  onChange: (v: string[]) => void
}

/**
 * Multi-select filter for value_type dimensions (e.g. netsales, topups).
 * Returns null when there is only one (or zero) distinct value_type — nothing
 * to filter in that case.
 */
export function ValueTypeFilter({ options, selected, onChange }: Props) {
  if (options.length <= 1) return null

  return (
    <Autocomplete
      multiple
      sx={{ minWidth: 240 }}
      options={options}
      value={selected}
      onChange={(_, next) => onChange(next)}
      renderInput={(params) => <TextField {...params} label="Value Type" />}
      renderTags={(v, getTagProps) =>
        v.map((option, index) => <Chip {...getTagProps({ index })} label={option} key={option} />)
      }
    />
  )
}
